import React from 'react'
import { styled } from '@mui/system'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { colorPalette } from '../../style/colorPalette'

const LinkContainer = styled('div')({
  padding: '12px 16px',
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
})

const LinkButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: '8px 12px',
  borderRadius: '4px',
  width: '100%',
  color: colorPalette.skyBlue[7],
  fontSize: '14px',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: colorPalette.skyBlue[1],
  },
})

export const SupportSiteLink: React.FC = () => {
  const handleClick = () => {
    window.open(process.env.FLAGXS_SUPPORT_SITE_URL, '_blank')
  }

  return (
    <LinkContainer>
      <LinkButton onClick={handleClick}>
        <OpenInNewIcon fontSize="small" />
        サポートサイトを開く
      </LinkButton>
    </LinkContainer>
  )
}
